import React, { Suspense } from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import LoadingSpinner from "../Components/ui/LoadingSpinner";

const OnePage = React.lazy(() => import("../pages/Landing/OnePage"));
const SalonsLocation = React.lazy(
  () => import("../pages/Landing/OnePage/salons-locations/SalonsLocation"),
);

const VendorLogin = React.lazy(
  () => import("../pages/vendor-login/VendorLogin"),
);
const VendorRegister = React.lazy(
  () => import("../pages/vendor-register/VendorRegister"),
);
const RegisterPage = React.lazy(() => import("../pages/register/RegisterPage"));
const AdminLogin = React.lazy(() => import("../pages/admin-login/AdminLogin"));
const Logout = React.lazy(() => import("../pages/Authentication/Logout"));
const Register = React.lazy(() => import("../pages/Authentication/Register"));
const ForgetPasswordPage = React.lazy(
  () => import("../pages/Authentication/ForgetPassword"),
);
const UserProfile = React.lazy(
  () => import("../pages/Authentication/user-profile"),
);
const EditProfile = React.lazy(
  () => import("../pages/vendor-dashboard/profile/EditProfile"),
);
const DashboardEcommerce = React.lazy(
  () => import("../pages/DashboardEcommerce"),
);

const Branches = React.lazy(
  () => import("../pages/vendor-dashboard/branches/Branches"),
);
const Bookings = React.lazy(
  () => import("../pages/vendor-dashboard/bookings/Bookings"),
);
const Services = React.lazy(
  () => import("../pages/vendor-dashboard/services/Services"),
);
const CalendarBookings = React.lazy(
  () => import("../pages/vendor-dashboard/calendar-bookings/CalendarBookings"),
);
const Tax = React.lazy(() => import("../pages/vendor-dashboard/tax/Tax"));
const StaffEarnings = React.lazy(
  () => import("../pages/vendor-dashboard/staff-earnings/StaffEarnings"),
);
const Promotions = React.lazy(
  () => import("../pages/vendor-dashboard/promotions/Promoions"),
);
const Staffs = React.lazy(
  () => import("../pages/vendor-dashboard/staffs/Staffs"),
);
const Customers = React.lazy(
  () => import("../pages/vendor-dashboard/customers/Customers"),
);
const Reviews = React.lazy(
  () => import("../pages/vendor-dashboard/reviews/Reviews"),
);
const Settings = React.lazy(
  () => import("../pages/vendor-dashboard/settings/Settings"),
);
const Categories = React.lazy(
  () => import("../pages/vendor-dashboard/categories/Categories"),
);
const SubCategories = React.lazy(
  () => import("../pages/vendor-dashboard/sub-categories/SubCategories"),
);
const Followers = React.lazy(
  () => import("../pages/vendor-dashboard/followers/Followers"),
);

const AdminDashboard = React.lazy(
  () => import("../pages/admin-dashboard/dashboard/Dashboard"),
);
const Vendors = React.lazy(
  () => import("../pages/admin-dashboard/vendors/Vendors"),
);
const AllSubscriptions = React.lazy(
  () => import("../pages/admin-dashboard/subscriptions/AllSubscriptions"),
);
const ActiveSubscription = React.lazy(
  () =>
    import("../pages/admin-dashboard/subscriptions/active-subscription/ActiveSubscription"),
);
const PendingSubscription = React.lazy(
  () =>
    import("../pages/admin-dashboard/subscriptions/pending-subscription/PendingSubscription"),
);
const ExpiredSubscription = React.lazy(
  () =>
    import("../pages/admin-dashboard/subscriptions/expired-subscription/ExpiredSubscription"),
);

const Plans = React.lazy(() => import("../pages/admin-dashboard/plans/Plans"));
const Payments = React.lazy(
  () => import("../pages/admin-dashboard/payments/Payments"),
);
const Blog = React.lazy(() => import("../pages/admin-dashboard/blog/Blog"));
const Notifications = React.lazy(
  () => import("../pages/admin-dashboard/notifications/Notifications"),
);
const LandingPageSettings = React.lazy(
  () =>
    import("../pages/admin-dashboard/landing-page-settings/LandingPageSettings"),
);
const Pages = React.lazy(() => import("../pages/admin-dashboard/pages/Pages"));
const AdminPromotions = React.lazy(
  () => import("../pages/admin-dashboard/promotions/Promotions"),
);
const AdminTax = React.lazy(() => import("../pages/admin-dashboard/tax/Tax"));
const States = React.lazy(
  () => import("../pages/admin-dashboard/states/States"),
);
const Cities = React.lazy(
  () => import("../pages/admin-dashboard/cities/Cities"),
);
const MusicLibrary = React.lazy(
  () => import("../pages/admin-dashboard/music/MusicLibrary")
);

const DashboardLayout = React.lazy(
  () => import("../pages/vendor-dashboard/DashboardLayout"),
);
const AdminLayout = React.lazy(
  () => import("../pages/admin-dashboard/AdminboardLayout"),
);
const IframeForm = React.lazy(() => import("../pages/iframe-form/IframeForm"));
const IframeTest = React.lazy(() => import("../pages/iframe-form/IframeTest"));
const SalonProfile = React.lazy(
  () => import("../pages/salon-profile/SalonProfile"),
);
const Booking = React.lazy(
  () => import("../pages/appointment/AppointmentPage"),
);
const Admins = React.lazy(
  () => import("../pages/admin-dashboard/admins/Admin"),
);
const ForgotPassword = React.lazy(
  () => import("../pages/forgot-password/ForgotPassword"),
);
const ResetPassword = React.lazy(
  () => import("../pages/reset-password/ResetPassword"),
);
const AdminSettings = React.lazy(
  () => import("../pages/admin-dashboard/settings/Settings"),
);
const WhyUs = React.lazy(() => import("../pages/Landing/OnePage/why-us/WhyUs"));
const CaseStudies = React.lazy(
  () => import("../pages/Landing/OnePage/case-studies/CaseStudies"),
);
const Pricing = React.lazy(
  () => import("../pages/Landing/OnePage/pricing/Pricing"),
);
const AboutUs = React.lazy(
  () => import("../pages/Landing/OnePage/abouts-us/AboutUS"),
);
const PrivacyPolicy = React.lazy(
  () => import("../pages/Landing/OnePage/privacy-policy/PrivacyPolicy")
);
const Terms = React.lazy(
  () => import("../pages/Landing/OnePage/terms/Terms")
);
const Impressum = React.lazy(
  () => import("../pages/Landing/OnePage/impressum/Impressum")
);
const WebsiteBlogs = React.lazy(
  () => import("../pages/Landing/OnePage/website-blogs/Blogs"),
);
const bookingWidget = React.lazy(
  () => import("../pages/vendor-dashboard/booking-widget/BookingWidget"),
);
const PaymentCheck = React.lazy(
  () => import("../pages/payment-check/PaymentCheck"),
);
const Menus = React.lazy(() => import("../pages/admin-dashboard/menus/Menus"));
const MenuItem = React.lazy(
  () => import("../pages/admin-dashboard/menus/MenuItemsPage"),
);
const NoPermission = React.lazy(
  () => import("../pages/no-permission/NoPermission"),
);

const DynamicPage = React.lazy(
  () => import("../pages/Landing/OnePage/dynamic-page/DynamicPage"),
);
const SalonSubscription = React.lazy(
  () =>
    import("../pages/vendor-dashboard/salon-subscription/SalonSubscription"),
);
const SubscriptionOver = React.lazy(
  () => import("../pages/subscription-over/SubscriptionOver"),
);
const SubscriptionPlans = React.lazy(
  () => import("../pages/subscription-plans/SubscriptionPlans"),
);

const PlansForSalon = React.lazy(() => import("../pages/plans/PlansForSalon"));
const BookingReview = React.lazy(
  () => import("../pages/customer-review/CustomerReview"),
);
const VerifyEmail = React.lazy(() => import("../pages/verify/VerifyEmail"));
const AdminFaqs = React.lazy(
  () => import("../pages/admin-dashboard/faqs/Faqs"),
);
const CustomerLayout = React.lazy(
  () => import("../pages/customer-dashboard/CustomerLayout"),
);
const CustomerBookingsPage = React.lazy(
  () => import("../pages/customer-dashboard/CustomerBookingsPage"),
);
const CustomerSocialPage = React.lazy(
  () => import("../pages/customer-dashboard/CustomerSocialPage"),
);
const FeedPage = React.lazy(() => import("../pages/feed/FeedPage"));

const EmployeeWorkSessions = React.lazy(
  () => import("../pages/vendor-dashboard/employee-work-sessions/WorkSessions"),
);
const OwnerPayroll = React.lazy(
  () => import("../pages/vendor-dashboard/owner-payroll/OwnerPayroll"),
);
const WithDraw = React.lazy(
  () => import("../pages/vendor-dashboard/withdraw/WithDraw"),
);
const Transactions = React.lazy(
  () => import("../pages/vendor-dashboard/transactions/Transactions"),
);
const AdminWithdraw = React.lazy(
  () => import("../pages/admin-dashboard/withdraw/AdminWithdraw"),
);
const AdminTransactions = React.lazy(
  () => import("../pages/admin-dashboard/transactions/AdminTransactions"),
);
const Reels = React.lazy(() => import("../pages/vendor-dashboard/reels/Reels"));
const Posts = React.lazy(() => import("../pages/vendor-dashboard/posts/Posts"));
const canAccessCalendar = (subscriptionData) => {
  if (!subscriptionData) return false;

  const isTrial = subscriptionData?.status === "trial";

  if (isTrial) {
    console.log("Subscription is trial - calendar access granted");
    return true;
  }

  const plan = subscriptionData?.subscription?.plan || {};
  const hasPermission = plan.includes_calendar_management === true;

  console.log("Calendar Check:", {
    isTrial: false,
    planPermission: hasPermission,
    subscriptionStatus: subscriptionData?.subscription?.status,
    plan,
  });

  return hasPermission;
};

const canAccessCustomers = (subscriptionData) => {
  if (!subscriptionData) return false;

  const isTrial = subscriptionData?.status === "trial";

  if (isTrial) {
    console.log("Subscription is trial - customers access granted");
    return true;
  }

  const plan = subscriptionData?.subscription?.plan || {};
  const hasPermission = plan.includes_customer_management === true;

  console.log("Customers Check:", {
    isTrial: false,
    planPermission: hasPermission,
    subscriptionStatus: subscriptionData?.status,
    plan,
  });

  return hasPermission;
};

const canAccessSalonPages = (subscriptionData) => {
  if (!subscriptionData) return false;

  const allowedStatuses = ["active", "trial"];

  return allowedStatuses.includes(subscriptionData.status);
};
const withSuspense = (Component) => (
  <Suspense fallback={<LoadingSpinner />}>
    <Component />
  </Suspense>
);
const authProtectedRoutes = [
  {
    path: "/guest",
    allowedRoles: ["customer"],
    element: withSuspense(CustomerLayout),
    children: [
      { index: true, component: withSuspense(CustomerBookingsPage) },
      { path: "bookings", component: withSuspense(CustomerBookingsPage) },
      { path: "social", component: withSuspense(CustomerSocialPage) },
    ],
  },
  {
    path: "/salon",

    allowedRoles: ["salon_owner", "employee"],
    element: withSuspense(DashboardLayout),
    children: [
      {
        index: true,
        component: () => {
          const { user } = useSelector((state) => state.user);

          if (!user) return <Navigate to="/login" replace />;

          if (user.role === "salon_owner")
            return withSuspense(DashboardEcommerce);
          if (user.role === "employee") return withSuspense(CalendarBookings);

          return <Navigate to="/no-permission" replace />;
        },
      },
      { path: "dashboard", component: withSuspense(DashboardEcommerce) },
      { path: "branches", component: withSuspense(Branches) },
      { path: "bookings", component: withSuspense(Bookings) },
      { path: "services", component: withSuspense(Services) },
      {
        path: "calendar-bookings",
        component: withSuspense(CalendarBookings),
        requiredPermissions: canAccessCalendar,
      },
      { path: "tax", component: withSuspense(Tax) },
      { path: "staff-earnings", component: withSuspense(StaffEarnings) },
      { path: "promotions", component: withSuspense(Promotions) },
      { path: "settings", component: withSuspense(Settings) },
      { path: "staffs", component: withSuspense(Staffs) },
      { path: "subscription", component: withSuspense(SubscriptionPlans) },
      { path: "plans", component: withSuspense(PlansForSalon) },
      { path: "work-sessions", component: withSuspense(EmployeeWorkSessions) },
      {
        path: "/salon/subscription/success",
        component: withSuspense(SalonSubscription),
      },

      {
        path: "customers",
        component: withSuspense(Customers),
        requiredPermissions: canAccessCustomers,
      },
      { path: "employees-payroll", component: withSuspense(OwnerPayroll) },
      { path: "reviews", component: withSuspense(Reviews) },
      { path: "booking-widget", component: withSuspense(bookingWidget) },
      { path: "profile", component: withSuspense(EditProfile) },
      { path: "withdraw", component: withSuspense(WithDraw) },
      { path: "transactions", component: withSuspense(Transactions) },
      { path: "reels", component: withSuspense(Reels) },
      { path: "posts", component: withSuspense(Posts) },
      { path: "followers", component: withSuspense(Followers) },
      { path: "*", component: <Navigate to="/salon" /> },
    ],
  },
  {
    path: "/admin",
    allowedRoles: ["admin"],
    element: withSuspense(AdminLayout),
    children: [
      { index: true, component: withSuspense(AdminDashboard) },
      { path: "dashboard", component: withSuspense(AdminDashboard) },
      { path: "salons", component: withSuspense(Vendors) },
      { path: "subscriptions", component: withSuspense(AllSubscriptions) },
      { path: "faqs", component: withSuspense(AdminFaqs) },
      {
        path: "active-subscription",
        component: withSuspense(ActiveSubscription),
      },
      {
        path: "pending-subscription",
        component: withSuspense(PendingSubscription),
      },
      {
        path: "expired-subscription",
        component: withSuspense(ExpiredSubscription),
      },
      { path: "plans", component: withSuspense(Plans) },
      { path: "payments", component: withSuspense(Payments) },
      { path: "promotions", component: withSuspense(AdminPromotions) },
      { path: "pages", component: withSuspense(Pages) },
      { path: "tax", component: withSuspense(AdminTax) },
      { path: "blog", component: withSuspense(Blog) },
      { path: "notifications", component: withSuspense(Notifications) },
      { path: "settings", component: withSuspense(AdminSettings) },
      { path: "admins", component: withSuspense(Admins) },
      { path: "categories", component: withSuspense(Categories) },

      { path: "sub-categories", component: withSuspense(SubCategories) },
      { path: "menus/:menuId", component: withSuspense(MenuItem) },
      { path: "menus", component: withSuspense(Menus) },
      {
        path: "landing-page-settings",
        component: withSuspense(LandingPageSettings),
      },
      { path: "states", component: withSuspense(States) },
      { path: "cities", component: withSuspense(Cities) },
      { path: "withdraws", component: withSuspense(AdminWithdraw) },
      { path: "transactions", component: withSuspense(AdminTransactions) },
      { path: "profile", component: withSuspense(EditProfile) },
      { path: "music-library", component: withSuspense(MusicLibrary) },
    ],
  },
];

const publicRoutes = [
  { path: "/", element: withSuspense(OnePage) },
  { path: "/why-starliccut", element: withSuspense(WhyUs) },
  { path: "/case-studies", element: withSuspense(CaseStudies) },
  { path: "/pricing", element: withSuspense(Pricing) },
  { path: "/about-us", element: withSuspense(AboutUs) },
  { path: "/privacy-policy", element: withSuspense(PrivacyPolicy) },
  { path: "/terms", element: withSuspense(Terms) },
  { path: "/impressum", element: withSuspense(Impressum) },
  { path: "/blogs", element: withSuspense(WebsiteBlogs) },
  { path: "/page/:slug", element: withSuspense(DynamicPage) },
  { path: "/booking/payment-check/:id", element: withSuspense(PaymentCheck) },

  { path: "/salons-location", element: withSuspense(SalonsLocation) },
  { path: "/logout", element: withSuspense(Logout) },
  { path: "/login", element: withSuspense(VendorLogin) },
  { path: "/register", element: withSuspense(RegisterPage) },
  { path: "/salon/register", element: withSuspense(VendorRegister) },
  { path: "/forgot-password", element: withSuspense(ForgotPassword) },
  { path: "/reset-password", element: withSuspense(ResetPassword) },
  { path: "/verify-email", element: withSuspense(VerifyEmail) },
  { path: "no-permission", element: withSuspense(NoPermission) },
  { path: "booking-review/:id", element: withSuspense(BookingReview) },
  { path: "subscription-over", element: withSuspense(SubscriptionOver) },
  { path: "/admin/login", element: withSuspense(AdminLogin) },
  { path: "booking-iframe/:salonID", element: withSuspense(IframeForm) },
  { path: "/salon-profile/:salonID", element: withSuspense(SalonProfile) },
  { path: "/booking/:salonID", element: withSuspense(Booking) },
  { path: "test-iframe", element: withSuspense(IframeTest) },
  { path: "/feed", element: withSuspense(FeedPage) },
];

export { authProtectedRoutes, publicRoutes };
